import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { EmployeeRow, AwardInput } from "redux/models/evl/evl0112p_model";

type InquiryCnds = {
  awardYear: string;
  instCd: string;
  empNm: string;
  deptNm: string;
  position: string;
  userStCd: string;
};

type Evl0112pState = {
  inquiryCnds: InquiryCnds;
  rows: EmployeeRow[];
  selectedEmpNos: string[];
  inputMap: Record<string, AwardInput>;
};

const getInitialInquiryCnds = (): InquiryCnds => ({
  awardYear: String(new Date().getFullYear()),
  instCd: "002",
  empNm: "",
  deptNm: "all",
  position: "all",
  userStCd: "A",
});

const initialState: Evl0112pState = {
  inquiryCnds: getInitialInquiryCnds(),
  rows: [],
  selectedEmpNos: [],
  inputMap: {},
};

const evl0112pSlice = createSlice({
  name: "Evl0112p",
  initialState,
  reducers: {
    setInquiryCnds(state, action: PayloadAction<Partial<InquiryCnds>>) {
      state.inquiryCnds = { ...state.inquiryCnds, ...action.payload };
    },
    resetInquiryCnds(state) {
      state.inquiryCnds = getInitialInquiryCnds();
    },
    setRows(state, action: PayloadAction<EmployeeRow[]>) {
      state.rows = action.payload;
    },
    setSelectedEmpNos(state, action: PayloadAction<string[]>) {
      state.selectedEmpNos = action.payload;
    },
    setInputMap(state, action: PayloadAction<Record<string, AwardInput>>) {
      state.inputMap = action.payload;
    },
    resetPopupState(state) {
      state.rows = [];
      state.selectedEmpNos = [];
      state.inputMap = {};
      state.inquiryCnds = getInitialInquiryCnds();
    },
  },
});

export const Evl0112pAction = evl0112pSlice.actions;
export default evl0112pSlice.reducer;